import ForSaleSwitches from "../utils/ForSaleSwitches";
import TelesoftSyncManager from './TelesoftSyncManager.js';

export default class ProductIndex {
  constructor() {
    this.switches = null;
    this.datatable = null;
    this.telesoftSync = new TelesoftSyncManager();
    this.bindEvents();
  }

  bindEvents() {
    const self = this;

    let show_actions = $('#products-datatable').data("show-actions") == true;
    
    var columns = [
      { "data": "type" },
      { "data": "name" },
      { "data": "unit" },
      { "data": "fas" },
      { "data": "subscription_price" },
      { "data": "commitment_period" }
    ];
  
    if (show_actions) {
        columns.push({ "data": "for_sale" });
        columns.push({ "data": "actions" });
    }

    self.datatable = $("#products-datatable").DataTable({
      "ajax": {
        'url': $('#products-datatable').data("url"),
        data: function (d) {
          d.order_by = $('#order_by').val();
          d.filter_fas = $('#fas-select').val();
          d.filter_subscription = $('#subscription-select').val();
          d.filter_unit = $('#unit-select').val();
          d.filter_duration = $('#duration-select').val();
        }
      },
      "language": {
        url: '/data-tables/locales/' + I18n.locale + '.json'
      },
      "order": [],
      "columns": columns,
      drawCallback:function(){
        $(".dataTables_paginate > .pagination").addClass("pagination-rounded")
        self.switches = new ForSaleSwitches();
      }
    });

    $(".filter-select").on("change", function() {
      self.onFilterChange(self);
    });

    $("#file-import-input").dropify({
      messages: {
      'default': I18n.t('plugins.dropify.messages.default'),
      'replace': I18n.t('plugins.dropify.messages.replace'),
      'remove': I18n.t('plugins.dropify.messages.remove'),
      'error': I18n.t('plugins.dropify.messages.error')
      },
      error: {
      'fileSize': I18n.t('plugins.dropify.error.fileSize'),
      'minWidth': I18n.t('plugins.dropify.error.minWidth'),
      'maxWidth': I18n.t('plugins.dropify.error.maxWidth'),
      'minHeight': I18n.t('plugins.dropify.error.minHeight'),
      'maxHeight': I18n.t('plugins.dropify.error.maxHeight'),
      'imageFormat': I18n.t('plugins.dropify.error.imageFormat'),
      'fileExtension': I18n.t('plugins.dropify.error.fileExtension'),
      }
    });

    // Handle export links
    $("#export-csv").on("click", function(e) {
      e.preventDefault();
      self.exportProducts('csv');
    });

    $("#export-excel").on("click", function(e) {
      e.preventDefault();
      self.exportProducts('xlsx');
    });

    // Bind bulk sync button
    $('#bulk-sync-telesoft-btn').on('click', () => {
      this.openBulkSyncModal();
    });

    this.initBulkTelesoftSyncModal();
  }

  initBulkTelesoftSyncModal() {
    const $modal = $('#bulkTelesoftSyncModal');
    if (!$modal.length) return;

    // Reset modal state when opened
    $modal.on('show.bs.modal', () => {
      this.resetBulkModalState();
    });

    // Handle confirm button click
    $('#bulk-confirm-sync-btn').on('click', () => {
      this.performBulkSync();
    });

    // Handle select all checkbox
    $('#select-all-products').on('change', (e) => {
      const checked = e.target.checked;
      $('.product-checkbox').prop('checked', checked);
    });

    // Handle individual product checkboxes
    $(document).on('change', '.product-checkbox', () => {
      this.updateSelectAllState();
    });
  }

  openBulkSyncModal() {
    // Get all products from the table
    const products = this.getAllProductsFromTable();
    
    if (products.length === 0) {
      application.errorNotification("Aucun produit trouvé pour la synchronisation");
      return;
    }

    // Store products data in modal
    $('#bulkTelesoftSyncModal').data('products', products);
    
    // Show modal and start checking
    $('#bulkTelesoftSyncModal').modal('show');
    this.performBulkCheck(products);
  }

  getAllProductsFromTable() {
    const products = [];
    const tableData = this.datatable.data();
    
    tableData.each(function(rowData) {
      if (rowData.DT_RowData) {
        products.push({
          id: rowData.DT_RowData['product-id'],
          name: rowData.DT_RowData['product-name'],
          code: rowData.DT_RowData['product-code']
        });
      }
    });
    
    return products;
  }

  performBulkCheck(products) {
    this.showBulkCheckingState();
    
    const bulkCheckUrl = $('#bulk-sync-telesoft-btn').data('bulk-check-url');
    
    this.telesoftSync.checkMultipleProducts(products, bulkCheckUrl)
    .done((data) => {
      if (data.success) {
        this.showBulkSelectionState(data.not_found_products);
      } else {
        this.showBulkResultState('error', data.error || 'Erreur lors de la vérification des produits.');
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error checking products:', error);
      this.showBulkResultState('error', 'Erreur lors de la vérification des produits dans Telesoft.');
    });
  }

  performBulkSync() {
    const selectedProductIds = [];
    $('.product-checkbox:checked').each(function() {
      selectedProductIds.push($(this).val());
    });

    if (selectedProductIds.length === 0) {
      application.errorNotification("Veuillez sélectionner au moins un produit à synchroniser");
      return;
    }

    this.showBulkProcessingState();

    const bulkSyncUrl = $('#bulk-sync-telesoft-btn').data('bulk-sync-url');

    this.telesoftSync.syncMultipleProducts(selectedProductIds, bulkSyncUrl)
    .done((data) => {
      if (data.success) {
        this.showBulkResultState('success', `${data.synced_count} produit(s) synchronisé(s) avec succès.`);
      } else {
        this.showBulkResultState('error', data.error || 'Erreur lors de la synchronisation.');
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error syncing products:', error);
      this.showBulkResultState('error', 'Erreur lors de la synchronisation avec Telesoft.');
    });
  }

  showBulkCheckingState() {
    $('#bulk-sync-initial-content').hide();
    $('#bulk-sync-selection').hide();
    $('#bulk-sync-checking').show();
    $('#bulk-sync-processing').hide();
    $('#bulk-sync-success').hide();
    $('#bulk-sync-error').hide();
    
    $('#bulk-confirm-sync-btn').prop('disabled', true);
  }

  showBulkSelectionState(notFoundProducts) {
    $('#bulk-sync-checking').hide();
    
    if (notFoundProducts.length === 0) {
      this.showBulkResultState('info', 'Tous les produits existent déjà dans Telesoft.');
      return;
    }

    $('#bulk-sync-selection').show();
    
    // Populate the product list
    const $productList = $('#products-to-sync-list');
    $productList.empty();
    
    notFoundProducts.forEach(product => {
      $productList.append(`
        <div class="form-check mb-2">
          <input class="form-check-input product-checkbox" type="checkbox" value="${product.id}" id="product-${product.id}" checked>
          <label class="form-check-label" for="product-${product.id}">
            <strong>${product.name}</strong> (${product.code})
          </label>
        </div>
      `);
    });

    $('#bulk-confirm-sync-btn').prop('disabled', false).show();
    $('#bulk-modal-cancel-btn').show();
    $('#bulk-modal-close-btn').hide();
  }

  showBulkProcessingState() {
    $('#bulk-sync-selection').hide();
    $('#bulk-sync-processing').show();
    $('#bulk-confirm-sync-btn').prop('disabled', true);
  }

  showBulkResultState(type, message) {
    $('#bulk-sync-selection').hide();
    $('#bulk-sync-processing').hide();
    $('#bulk-sync-checking').hide();
    
    if (type === 'success') {
      $('#bulk-sync-success').show();
      $('#bulk-sync-success .alert').text(message);
    } else if (type === 'error') {
      $('#bulk-sync-error').show();
      $('#bulk-sync-error-message').text(message);
    } else if (type === 'info') {
      $('#bulk-sync-info').show();
      $('#bulk-sync-info .alert').text(message);
    }
    
    // Hide action buttons, show close button
    $('#bulk-confirm-sync-btn').hide();
    $('#bulk-modal-cancel-btn').hide();
    $('#bulk-modal-close-btn').show();
  }

  resetBulkModalState() {
    $('#bulk-sync-checking').hide();
    $('#bulk-sync-selection').hide();
    $('#bulk-sync-processing').hide();
    $('#bulk-sync-success').hide();
    $('#bulk-sync-error').hide();
    $('#bulk-sync-info').hide();
    
    $('#bulk-confirm-sync-btn').show().prop('disabled', false);
    $('#bulk-modal-cancel-btn').show();
    $('#bulk-modal-close-btn').hide();
  }

  updateSelectAllState() {
    const totalCheckboxes = $('.product-checkbox').length;
    const checkedCheckboxes = $('.product-checkbox:checked').length;
    
    $('#select-all-products').prop('indeterminate', checkedCheckboxes > 0 && checkedCheckboxes < totalCheckboxes);
    $('#select-all-products').prop('checked', checkedCheckboxes === totalCheckboxes);
  }

  onFilterChange(self) {
    self.datatable.ajax.reload();
  }

  exportProducts(format) {
    const params = {
      order_by: $('#order_by').val(),
      filter_fas: $('#fas-select').val(),
      filter_subscription: $('#subscription-select').val(),
      filter_unit: $('#unit-select').val(),
      filter_duration: $('#duration-select').val()
    };

    const queryString = $.param(params);
    const url = `/products/export_products.${format}?${queryString}`;
    window.location.href = url;
  }

  onDataChanged(data) {}

  onDestroy() {
    this.switches.onDestroy();
    this.datatable.destroy();
    
    // Clean up event listeners
    $('#bulk-sync-telesoft-btn').off('click');
    $('#bulkTelesoftSyncModal').off('show.bs.modal');
    $('#bulk-confirm-sync-btn').off('click');
    $('#select-all-products').off('change');
    $(document).off('change', '.product-checkbox');
  }
}